/** @jsxImportSource react */
/** @jsxFactory React.createElement */
/** @jsxFragmentFactory React.Fragment */

import { useMemo, useState } from 'react';
import './App.scss';
import { Drawing } from './Drawing';

const sendConfig = (img?: string) => {
	const newConfig = {
		config: {
			img: img,
		},
		validationError: img
			? undefined
			: 'No drawing',
		style: {
			desktop: `
				width: 100%;
				aspect-ratio: 16/11;
			`,
			mobile: `
				width: 100%;
				aspect-ratio: 16/11;
			`,
		},
	};
	window.parent?.postMessage(newConfig, '*');
}

export default function Config() {
	const streamPreview = useMemo(() => new URL(window.location.href).searchParams.get('streamPreviewURL') ?? undefined, []);
	const width = useMemo(() => Number(new URL(window.location.href).searchParams.get('width') ?? 640), []);
	const height = useMemo(() => Number(new URL(window.location.href).searchParams.get('height') ?? 360), []);
	const [img, setImg] = useState<string | undefined>(undefined);
	useMemo(() => sendConfig(img), [img]);
	return (
		<div className="w-full h-[100vh]">
			<Drawing width={width} height={height} onDrawDone={setImg} config={{ backgroundImage: streamPreview }} ensureControlsInViewport={true} />
		</div>
	);
}
